let isAvailable = false;
// если закрыт доступ к localStorage в браузере, то при вызове localStorage ошибка
try {
  isAvailable = typeof localStorage !== 'undefined' && !!localStorage;
} catch (e) {
  console.error(e);
}

export const isLocalStorageAvailable = isAvailable;
